import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import TylenolAutismWrapper from "@components/layouts/tylenolautismWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function TylenolAutismHome(): ReactElement {
    return (
        <TylenolAutismWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Tylenol"
                    domain="TylenolAutism.claims"
                />
            </div>
        </TylenolAutismWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
